export enum EPosition {
  default,
  Fixed,
  FixedHidden,
}
